/**
 * Created by Sale on 8/29/2024
 */
import {Role} from "@/utils/utils";
import archivePage from "@/modules/arhiving-module/views/archive/archive-page.vue";

const Module = () => import("./Module.vue");

const moduleRoute = {
    path: "/archive",
    component: Module,
    children: [
        {
            path: '/',
            name: 'archive',
            meta: {
                product: 'Realite Admin',
                title: 'Archive',
                isSubCategory: false,
                roles: [Role.ADMIN, Role.TRAFFIC_ENG],
                permission:'data-packaging:get-packaging-report',
                topBarTitle: '',
                menuPriority: 12,
                hasMenu: true,
                hasInternalTransition: false
            },
            component: archivePage
        }
    ]
};

export default router => {
    router.addRoutes([moduleRoute]);
};
